
export default {
  data() {
    return {
      operationSystems: [
        {
          name: "خرید سرور ابری ویندوزی ",
          cap: "سرور ویندوزی خود را از بین نسخه‌های پرکاربرد ویندوز ایجاد و به‌سرعت و به‌سادگی شروع به استفاده از سرور کنید.",
          apps: [
            {
              app: "Windows 2019",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۱۹ در خرید سرور ابری",
              title: "ویندوز سرور ۲۰۱۹ در کلود سرور",
            },
            {
              app: "Windows 2016",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۱۶ در خرید سرور ابری",
              title: "ویندوز سرور ۲۰۱۶ در کلود سرور",
            },
            {
              app: "Windows 2022",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۲۲ در خرید سرور ابری",
              title: "ویندوز سرور ۲۰۲۲ در کلود سرور",
            },
          ],
        },
        {
          name: "خرید سرور ابری لینوکسی ",
          cap: "سرور لینوکسی خود را با انتخاب از بین طیف متنوع توزیع‌های لینوکس بسازید و در یک دقیقه شروع به استفاده از سرور کنید.",
          apps: [
            {
              app: "CentOS 7.8",
              img: "centos.svg",
              alt: "امکان انتخاب CentOS در خرید سرور ابری",
              title: "CentOS در کلود سرور",
            },
            {
              app: "Mikrotik RouterOS",
              img: "mikrotik.svg",
              alt: "امکان انتخاب سیستم‌عامل میکروتیک در خرید سرور ابری",
              title: "سیستم‌عامل میکروتیک در کلود سرور",
            },
            {
              app: "Debian 11",
              img: "debian.svg",
              alt: "امکان انتخاب دبیان در خرید سرور ابری",
              title: "دبیان در کلود سرور",
            },
            {
              app: "Ubuntu 18.04",
              img: "ubuntu18.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور ابری",
              title: "اوبونتو در کلود سرور",
            },
            {
              app: "AlmaLinux 8.6",
              img: "AlmaLinux.svg",
              alt: "امکان انتخاب AlmaLinux در خرید سرور ابری",
              title: "AlmaLinux در کلود سرور",
            },
            // {
            //   app: "pfSense CE",
            //   img: "PfSense.svg",
            //   alt: "امکان انتخاب pfSense در خرید سرور ابری",
            //   title: "pfSense در کلود سرور",
            // },
            {
              app: "Ubuntu 20.04",
              img: "ubuntu18.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور مجازی",
              title: "اوبونتو در وی پی اس",
            },
            {
              app: "Rocky 9",
              img: "Rocky_Linux.svg",
              alt: "امکان انتخاب راکی در خرید سرور ابری",
              title: "راکی در کلود سرور",
            },
            {
              app: "Ubuntu 22.04",
              img: "ubuntu22.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور ابری",
              title: "اوبونتو در کلود سرور",
            },
            {
              app: "Fedora 36",
              img: "Fedora.svg",
              alt: "امکان انتخاب فدورا در خرید سرور ابری",
              title: "فدورا در کلود سرور",
            },
          ],
        },
        {
          name: "بازارچه ابری",
          cap: "از بین انواع اپلیکیشن‌های کاربردی، هر آنچه را که نیاز دارید انتخاب کنید و در سرور خود به صورت از پیش نصب شده و آماده استفاده تحویل بگیرید.",
          apps: [
            {
              app: "Node.js",
              img: "nodejs.svg",
              alt: "NodeJS روی  سرور ابری",
              title: "NodeJS روی سرور ابری",
            },
            {
              app: "Docker",
              img: "docker.svg",
              alt: "داکر روی  سرور ابری",
              title: "داکر روی سرور ابری",
            },
            {
              app: "WordPress",
              img: "wordpress.svg",
              alt: "ورد پرس روی  سرور ابری",
              title: "ورد پرس روی سرور ابری",
            },
            {
              app: "NGINX",
              img: "nginx.svg",
              alt: "انجین اکس روی  سرور ابری",
              title: "انجین اکس روی  سرور ابری",
            },
            {
              app: "MySQL",
              img: "mysql.svg",
              alt: "MySQL روی  سرور ابری",
              title: "MySQL روی  سرور ابری",
            },
            {
              app: "Apache",
              img: "apache.svg",
              alt: "آپاچی روی  سرور ابری",
              title: "آپاچی روی سرور ابری",
            },
          ],
        },
      ],
      activeIndex: 1,
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
